export default __webpack_public_path__ + "static/media/lesson.590609f5.png";